import {Action} from 'redux'
import * as actionTypes from './actionTypes'
import {TAction} from './actions'
import {IState} from './model'

const initialState: IState = {
  hasCreatedAccount: null
}

const reducer = (state: IState = initialState, action: TAction): IState => {
  switch (action.type) {
    case actionTypes.SET_HAS_CREATED_ACCOUNT:
      return {
        ...state,
        hasCreatedAccount: action.payload
      }
    case actionTypes.RESET_HAS_CREATED_ACCOUNT:
      return {
        ...state,
        hasCreatedAccount: null
      }
    default:
      return state
  }
}

// TODO: Workaround for redux typings issue. Fixed in redux v4.
// https://github.com/reactjs/redux/issues/2709
export default (state: IState, action: Action) => reducer(state, action as TAction)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/register/reducer.ts